import { Component } from '@angular/core';

@Component({
    selector: 'nsdva1',
    templateUrl: './nsdva1.component.html',
    styleUrl: './nsdva1.component.scss',
    standalone: false
})
export class Nsdva1Component {

}
